//--- ARQUIVO COMPLETO E ATUALIZADO: SetupScreen.js (Opções Limpas) ---
import React, { useState } from 'react';

// Função para formatar o CNPJ
const formatCnpj = (value) => { //
    const numericValue = value.replace(/[^\d]/g, ''); //

    return numericValue
        .replace(/(\d{2})(\d)/, '$1.$2') //
        .replace(/(\d{3})(\d)/, '$1.$2') //
        .replace(/(\d{3})(\d)/, '$1/$2') //
        .replace(/(\d{4})(\d{1,2})/, '$1-$2') //
        .substring(0, 18); //
};

export const SetupScreen = ({ onSave, showNotification }) => { //
    // Estado para guardar as informações do formulário
    const [meiInfo, setMeiInfo] = useState({ nome: '', cnpj: '', dataAbertura: '', tipoMEI: '' }); //
    const [isSaving, setIsSaving] = useState(false); //

    // Função chamada quando o formulário é enviado
    const handleSubmit = async (e) => { //
        e.preventDefault(); //
        // Valida se todos os campos foram preenchidos antes de salvar
        if (meiInfo.nome && meiInfo.cnpj && meiInfo.dataAbertura && meiInfo.tipoMEI) { //
            setIsSaving(true); //
            try {
                await onSave(meiInfo); //
            } finally {
                setIsSaving(false); //
            }
        } else {
            showNotification("Por favor, preencha todos os campos, incluindo o tipo de MEI."); //
        }
    };

    // Função para atualizar o estado a cada mudança nos campos
    const handleChange = (e) => { //
        const { name, value } = e.target; //
        if (name === 'cnpj') { //
            setMeiInfo(prev => ({ ...prev, [name]: formatCnpj(value) })); //
        } else {
            setMeiInfo(prev => ({ ...prev, [name]: value })); //
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center p-4">
            <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
                <h1 className="text-3xl font-bold text-center text-gray-800 dark:text-gray-200 mb-2">Bem-vindo(a)!</h1>
                <p className="text-center text-gray-500 dark:text-gray-400 mb-8">Vamos configurar as informações da sua empresa MEI.</p>
                
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="nome" className="dark:text-gray-300">Nome da Empresa</label>
                        <input type="text" name="nome" id="nome" value={meiInfo.nome} onChange={handleChange} required disabled={isSaving} className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                    </div>
                    <div>
                        <label htmlFor="cnpj" className="dark:text-gray-300">CNPJ</label>
                        <input type="text" name="cnpj" id="cnpj" value={meiInfo.cnpj} onChange={handleChange} required placeholder="00.000.000/0001-00" disabled={isSaving} className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                    </div>
                    <div>
                        <label htmlFor="dataAbertura" className="dark:text-gray-300">Data de Abertura</label>
                        <input type="date" name="dataAbertura" id="dataAbertura" value={meiInfo.dataAbertura} onChange={handleChange} required disabled={isSaving} className="mt-1 block w-full form-input dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                    </div>
                    
                    {/* === <select> ATUALIZADO E LIMPO === */}
                    <div>
                        <label htmlFor="tipoMEI" className="dark:text-gray-300">Tipo de MEI</label>
                        <select name="tipoMEI" id="tipoMEI" value={meiInfo.tipoMEI} onChange={handleChange} required disabled={isSaving} className="mt-1 block w-full form-select dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                            <option value="" disabled>Selecione seu tipo de atividade</option>
                            <option value="comercio_industria">Comércio ou Indústria</option>
                            <option value="servicos">Prestador de Serviços</option>
                            <option value="comercio_servicos">Comércio e Serviços</option>
                            <option value="caminhoneiro_inter">MEI Caminhoneiro - Intermunicipal</option>
                            <option value="caminhoneiro_icms_iss">MEI Caminhoneiro - Municipal/Mudanças</option>
                        </select>
                    </div>
                     {/* === FIM DA ATUALIZAÇÃO === */}

                    <div>
                        <button type="submit" disabled={isSaving} className="w-full flex justify-center py-3 px-4 border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 disabled:cursor-not-allowed">
                            {isSaving ? 'Salvando...' : 'Salvar e Começar'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};